import { Link } from "react-router-dom";
import { COMPANY, IMAGES } from "@/data/content";

export const Logo = ({ light = false, className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="site-logo"
      className={`flex items-center gap-2.5 group ${className}`}
      aria-label={`${COMPANY.name} home`}
    >
      <img
        src={IMAGES.logo}
        alt="AutoDrive Tech Solutions logo"
        className="h-12 w-12 sm:h-[52px] sm:w-[52px] rounded-full object-cover shrink-0 shadow-sm"
        loading="eager"
      />
      <span className="hidden sm:flex flex-col leading-none">
        <span className={`font-display font-bold text-[17px] tracking-tight ${light ? "text-white" : "text-[#0F172A]"}`}>
          AutoDrive
        </span>
        <span className={`text-[10px] font-medium tracking-[0.18em] uppercase ${light ? "text-blue-200" : "text-slate-500"}`}>
          Tech Solutions
        </span>
      </span>
    </Link>
  );
};
